import type { SectionItemPresentationVm } from '../viewModels/newHome.vm';
import { NEW_HOME_SECTION_VIEWED_NAME_REELS } from './homePageSectionViewed';

/** Tap on reel video / poster area (not the product bar). */
export const HOME_PAGE_REEL_CLICKED = 'Home Page Reel Clicked';

/** Tap on the product title bar (thumbnail, title, category, Buy). */
export const HOME_PAGE_REEL_PRODUCT_CLICKED = 'Home Page Reel Product Clicked';

/** Fired when a reel card is sufficiently visible in the viewport (once per position). */
export const HOME_PAGE_REEL_CARD_VIEWED = 'Home Page Reel Card Viewed';

function resolveReelProductId(productIds?: string[]): string {
  if (!productIds?.length) return '';
  const first = productIds[0];
  return first != null && String(first).trim() !== '' ? String(first).trim() : '';
}

/** Shared payload for reel click and viewed events. */
export function homePageReelEventProperties(
  item: Pick<SectionItemPresentationVm, 'position' | 'title' | 'productIds'>,
): Record<string, string | number> {
  return {
    'Section Name': NEW_HOME_SECTION_VIEWED_NAME_REELS,
    Position: item.position,
    'Product Id': resolveReelProductId(item.productIds),
    'Product Name': item.title,
  };
}

export const homePageReelClickEventProperties = homePageReelEventProperties;
export const homePageReelCardViewedEventProperties = homePageReelEventProperties;
